import {
	formatText,
	PRESETS,
	snapValueToStep,
	type NumericInput,
} from '@velocity-exchange/common/format';

/**
 * Base size display text: snapped to the market step then printed exactly, so
 * it never shows an exponent or digits finer than the step. Without a step
 * (market data not loaded yet) the value prints as-is.
 */
export function buildBaseSizeText(
	value: NumericInput,
	step: NumericInput | undefined
): string {
	const snapped =
		step === undefined ? value : snapValueToStep(value, step, 'toward-zero');
	// `snapValueToStep` returns null for a step <= 0 (a malformed account, not
	// a real market); an empty field beats the library's default '-', which
	// could otherwise land as literal text in an editable size input.
	return formatText(snapped, { ...PRESETS.printShort, fallback: '' });
}

/**
 * Quote size display text: half-up at 2 decimals, computed on the input's own
 * exact fixed-point scale so a float tie rounds correctly.
 */
export function buildQuoteSizeText(value: NumericInput): string {
	return formatText(value, {
		digits: { kind: 'decimals', decimals: 2, rounding: 'half-up' },
		grouping: false,
	});
}
